import { Camelized } from 'humps';

export enum BalanceAccountStatus {
  ACTIVE = 'active',
  PENDING_ACTIVATION = 'pendingActivation',
  SUSPENDED = 'suspended',
  TERMINATED = 'terminated',
}

export enum BalanceCardBrand {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DINERS = 'diners',
  DISCOVER = 'discover',
  JCB = 'jcb',
  UNIONPAY = 'unionpay',
}

export enum BalanceCardFunding {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export interface BalanceCreditInfoRawResponse {
  account_status: BalanceAccountStatus;
  credit_limit: number | null;
  available_credit: number | null;
}

export interface BalancePaymentMethodCardRaw {
  id: string;
  brand: BalanceCardBrand;
  funding: BalanceCardFunding;
  last_four_digits: string;
  expiration_month: number;
  expiration_year: number;
  is_default: boolean;
}

export interface BalancePaymentMethodBankRaw {
  id: string;
  institution_name: string;
  account_name: string;
  account_number_mask: string;
  is_default: boolean;
}

export interface BalancePaymentMethodsRawResponse {
  cards: BalancePaymentMethodCardRaw[];
  banks: BalancePaymentMethodBankRaw[];
}

export enum PaymentMethodType {
  CARD = 'card',
  BANK = 'bank',
}

export interface BalancePortalUrlRawResponse {
  portal_url: string;
}

export interface BalanceCreditApplicationUrlRawResponse {
  credit_application_url: string;
}

export type BalanceCreditInfoApiResponse =
  Camelized<BalanceCreditInfoRawResponse>;

export type BalancePaymentMethodCard = Camelized<BalancePaymentMethodCardRaw>;

export type BalancePaymentMethodBank = Camelized<BalancePaymentMethodBankRaw>;

export type BalancePaymentMethodsApiResponse =
  Camelized<BalancePaymentMethodsRawResponse>;

export type BalancePortalUrlApiResponse =
  Camelized<BalancePortalUrlRawResponse>;

export type BalanceCreditApplicationUrlApiResponse =
  Camelized<BalanceCreditApplicationUrlRawResponse>;
